import { SITE } from "@/constants/testIds";

/** Key financial metrics grid on the report page. */
export function ReportMetrics({ metrics }) {
  if (metrics.length === 0) return null;
  return (
    <div data-testid={SITE.reportMetrics} className="rounded-xl border border-kira-border bg-kira-surface p-6 mb-6">
      <p className="font-mono text-[11px] uppercase tracking-[0.2em] text-kira-gold mb-4">
        Key Financial Metrics
      </p>
      <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-x-8 gap-y-3">
        {metrics.map((m, i) => (
          <div key={`${m.label}-${i}`} className="flex justify-between items-baseline gap-4 border-b border-kira-border/60 pb-2">
            <span className="text-xs text-kira-textMuted font-mono truncate">{m.label}</span>
            <span className="text-sm font-mono font-semibold text-white whitespace-nowrap">{m.value}</span>
          </div>
        ))}
      </div>
    </div>
  );
}
